import { create } from 'zustand';

import { VideoTab } from '@/shared/ui/VideoPlayer/views/ProjectVideoPlayer/types';

type VideoTabStore = {
  activeTab: VideoTab;
  setActiveTab: (tab: VideoTab) => void;
};

export const useVideoTabStore = create<VideoTabStore>((set) => ({
  activeTab: VideoTab.SrcVideo,
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
